import {types} from '../../utils/js/types';
import {GMI, STATE} from '../../constants';
import request from '../request';
import services from '../../services';
import {batchActions} from '../../utils/redux';
import { List } from 'immutable';
import { isArrayNotEmpty } from '../../utils/js/array';
import { get } from '../../utils/js/object';
import { callFunctionWithObjPathValues } from '../../utils/js/function';


const {DRIVER_PROFILE} = STATE.UI.RESERVATIONS;
const CONTACT = DRIVER_PROFILE.concat(['contact']);
const ADDRESS = DRIVER_PROFILE.concat(['address']);
const DRIVERS_LICENSE = DRIVER_PROFILE.concat(['drivers_license']);

export const driverProfilePaths = {
  first_name: DRIVER_PROFILE.concat(['first_name']),
  last_name: DRIVER_PROFILE.concat(['last_name']),
  date_of_birth: DRIVER_PROFILE.concat(['date_of_birth']),
  contact: {
    email: CONTACT.concat(['email']),
    phones: CONTACT.concat(['phones'])
  },
  address: {
    city: ADDRESS.concat(['city']),
    country_code: ADDRESS.concat(['country_code']),
    country_name: ADDRESS.concat(['country_name']),
    country_subdivision_code: ADDRESS.concat(['country_subdivision_code']),
    country_subdivision_name: ADDRESS.concat(['country_subdivision_name']),
    postal: ADDRESS.concat(['postal']),
    street_addresses: ADDRESS.concat(['street_addresses'])
  },
  drivers_license: {
    country_code: DRIVERS_LICENSE.concat(['country_code']),
    country_name: DRIVERS_LICENSE.concat(['country_name']),
    country_subdivision_code: DRIVERS_LICENSE.concat(['country_subdivision_code']),
    country_subdivision_name: DRIVERS_LICENSE.concat(['country_subdivision_name']),
    license_expiration_date: DRIVERS_LICENSE.concat(['license_expiration_date']),
    license_issue_date: DRIVERS_LICENSE.concat(['license_issue_date']),
    license_number: DRIVERS_LICENSE.concat(['license_number'])
  }
};

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoState() {
  const initialDriverInfo = {
    contact: {},
    address: {},
    drivers_license: {}
  };
  return {type: GMI.SET_GMI_STATE, path: DRIVER_PROFILE, value: initialDriverInfo};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoContact() {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.contact, value:{}};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoAdress() {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address, value:{}};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriversLicense() {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license, value:{}};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoFirstName() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.first_name};
}

/**
 * @private
 * @param {String} first_name
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoFirstName(first_name) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.first_name, value: first_name};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoLastName() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.last_name};
}

/**
 * @private
 * @param {String} last_name
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoLastName(last_name) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.last_name, value: last_name};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDOB() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.date_of_birth};
}

/**
 * @private
 * @param {String} date_of_birth
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoDOB(date_of_birth) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.date_of_birth, value: date_of_birth};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoEmail() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.contact.email};
}

/**
 * @private
 * @param {String} email
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoEmail(email) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.contact.email, value: email};
}

/**
 * @private
 * @desc Returns action to remove a specific phone object or the whole phones array from state
 * @param {Object} opts {
 *   index: Number,
 *   state: Object
 * }
 * @returns {Object} {type: string, path: [], value: []}
 */
function unsetDriverInfoStatePhones(opts) {
  const {index, state} = opts;
  let value = state.getIn(driverProfilePaths.contact.phones, List([])).toJS();

  if (types(index).inNumber && types(value[index]).isDefined) {
    value.splice(index, 1);
    return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.contact.phones, value};
  }

  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.contact.phones};
}

/**
 * @private
 * @param {Number} index
 * @returns {Function}
 */
function clearDriverInfoPhones(index = null) {
  return (dispatch, getState) => dispatch(unsetDriverInfoStatePhones({index, state: getState()}));
}

/**
 * @private
 * @param {Array} value
 * @returns {Object} {type: string, path: [], value: []}
 */
function setDriverInfoStatePhones(value) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.contact.phones, value};
}

/**
 * @private
 * @desc Returns a function that dispatches the set phones action by using the index option to determine if the
 * phones parameteer needs to be replaced or enhanced
 * @param {Array | Object phones
 * @param {Number} index
 * @returns {Function}
 */
function setDriverInfoPhones(phones, index = null) {
  return (dispatch, getState) => {
    const state = getState();
    let value = state.getIn(driverProfilePaths.contact.phones, List([])).toJS();

    if (types(phones).isArray) {
      value = phones;
    } else if (types(value[index]).isDefined) {
      value[index] = phones;
    } else {
      value.unshift(phones);
    }

    return dispatch(setDriverInfoStatePhones(value));
  };
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoAddressCity() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.address.city};
}

/**
 * @private
 * @param {String} city
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoAddressCity(city) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.city, value: city};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoAddressCountryCode() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.address.country_code};
}

/**
 * @private
 * @param {String} country_code
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoAddressCountryCode(country_code) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.country_code, value: country_code};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoAddressCountryName() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.address.country_name};
}

/**
 * @private
 * @param {String} country_name
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoAddressCountryName(country_name) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.country_name, value: country_name};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoAddressSubdivisionCode() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.address.country_subdivision_code};
}

/**
 * @private
 * @param {String} country_subdivision_code
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoAddressSubdivisionCode(country_subdivision_code) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.country_subdivision_code, value: country_subdivision_code};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoAddressSubdivisionName() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.address.country_subdivision_name};
}

/**
 * @private
 * @param {String} country_subdivision_name
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoAddressSubdivisionName(country_subdivision_name) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.country_subdivision_name, value: country_subdivision_name};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoAddressPostal() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.address.postal};
}

/**
 * @private
 * @param {String} postal
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoAddressPostal(postal) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.postal, value: postal};
}

/**
 * @private
 * @desc Returns action to remove a specific street address or the whole street_addresses array from state
 * @param {Object} opts {
 *   index: Number,
 *   state: Object
 * }
 * @returns {Object} {type: string, path: [], value: []}
 */
function unsetDriverInfoStateStreetAddresses(opts) {
  const {index, state} = opts;
  let value = state.getIn(driverProfilePaths.address.street_addresses, List([])).toJS();

  if (types(index).inNumber && types(value[index]).isDefined) {
    value.splice(index, 1);
    return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.street_addresses, value};
  }

  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.address.street_addresses};
}

/**
 * @private
 * @param {Number} index
 * @returns {Function}
 */
function clearDriverInfoAddressStreetAddresses(index = null) {
  return (dispatch, getState) => dispatch(unsetDriverInfoStateStreetAddresses({index, state:getState()}));
}

/**
 * @private
 * @param {Array} value
 * @returns {Object} {type: string, path: [], value: []}
 */
function setDriverInfoStateStreetAddresses(value) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.address.street_addresses, value};
}


/**
 * @private
 * @desc Returns a function that dispatches the set street_addresses action by using the index option to determine if the
 * street_addresses parameteer needs to be replaced or enhanced
 * @param {Object | Array} street_addresses
 * @param {Number} index
 * @returns {Function}
 */
function setDriverInfoAddressStreetAddresses(street_addresses, index = null) {
  return (dispatch, getState) => {
    const state = getState();
    let value = state.getIn(driverProfilePaths.address.street_addresses, List([])).toJS();

    if (types(street_addresses).isArray) {
      value = street_addresses;
    } else if (types(index).inNumber && types(value[index]).isDefined) {
      value[index] = street_addresses;
    } else {
      value.unshift(street_addresses);
    }
    return dispatch(setDriverInfoStateStreetAddresses(value));
  };
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriverLicenseCountryCode() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.drivers_license.country_code};
}

/**
 * @private
 * @param {String} country_code
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoDriverLicenseCountryCode(country_code) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license.country_code, value: country_code};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriverLicenseCountryName() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.drivers_license.country_name};
}

/**
 * @private
 * @param {String} country_name
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoDriverLicenseCountryName(country_name) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license.country_name, value: country_name};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriverLicenseCountrySubdivisionCode() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.drivers_license.country_subdivision_code};
}

/**
   * @private
   * @param {String} country_subdivision_code
   * @returns {Object} {type: string, path: [], value: string}
   */
function setDriverInfoDriverLicenseCountrySubdivisionCode(country_subdivision_code) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license.country_subdivision_code, value: country_subdivision_code};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriverLicenseCountrySubdivisionName() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.drivers_license.country_subdivision_name};
}

/**
 * @private
 * @param {String} country_subdivision_name
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoDriverLicenseCountrySubdivisionName(country_subdivision_name) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license.country_subdivision_name, value: country_subdivision_name};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriverLicenseExpirationDate() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.drivers_license.license_expiration_date};
}

/**
 * @private
 * @param {String} license_expiration_date
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoDriverLicenseExpirationDate(license_expiration_date) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license.license_expiration_date, value: license_expiration_date};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriverLicenseIssueDate() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.drivers_license.license_issue_date};
}

/**
 * @private
 * @param {String} license_issue_date
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoDriverLicenseIssueDate(license_issue_date) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license.license_issue_date, value: license_issue_date};
}

/**
 * @private
 * @returns {Object} {type: string, path: []}
 */
function clearDriverInfoDriverLicenseNumber() {
  return {type: GMI.DELETE_GMI_STATE, path: driverProfilePaths.drivers_license.license_number};
}

/**
 * @private
 * @param {String} license_number
 * @returns {Object} {type: string, path: [], value: string}
 */
function setDriverInfoDriverLicenseNumber(license_number) {
  return {type: GMI.SET_GMI_STATE, path: driverProfilePaths.drivers_license.license_number, value: license_number};
}


export const driverProfileState = {
  /**
   * @name set
   * @desc A global setter for all reservation.driver_info data
   * @param {String} [type]
   * @param {Object} [args]
   * @returns {Function}
   * @memberof actions.reservations.driverProfileState
   * @example
   *
   * // set first name
   * store.dispatch(actions.reservations.driverProfileState.set('first_name', {first_name:'John'}));
   *
   * // set last name
   * store.dispatch(actions.reservations.driverProfileState.set('last_name', {last_name:'Doe'}));
   *
   * // set date_of_birth name
   * store.dispatch(actions.reservations.driverProfileState.set('date_of_birth', {date_of_birth:'11-18-1990'}));
   *
   * // set emal
   * store.dispatch(actions.reservations.driverProfileState.set('email', {email:'jdoe@test.com'}));
   *
   * // set phone numbers
   * store.dispatch(actions.reservations.driverProfileState.set('phones', {phones:[{
                "mask_phone_number": "••••••0263",
                "phone_type": "HOME",
                "priority": 1,
                "country_code": "US",
                "country_name": "United States"}]}));
   *
   * // set city
   * store.dispatch(actions.reservations.driverProfileState.set('city', {city:'Chicago'}));
   *
   * // set address country code
   * store.dispatch(actions.reservations.driverProfileState.set('address.country_code', {country_code:'US'}));
   *
   * // set address country name
   * store.dispatch(actions.reservations.driverProfileState.set('address.country_name', {country_name:'United States'}));
   *
   * // set address subdivision country code
   * store.dispatch(actions.reservations.driverProfileState.set('address.country_subdivision_code', {country_subdivision_code:'IL'}));
   *
   * // set address subdivision country name
   * store.dispatch(actions.reservations.driverProfileState.set('address.country_subdivision_name', {country_subdivision_name:'Illinois'}));
   *
   * // set postal code
   * store.dispatch(actions.reservations.driverProfileState.set('postal', {postal:'60601'}));
   *
   * // set street addresses
   * store.dispatch(actions.reservations.driverProfileState.set('street_addresses', {street_addresses:["** ***olph"]}));
   *
   * // set license country code
   * store.dispatch(actions.reservations.driverProfileState.set('drivers_license.country_code', {country_code:'US'}));
   *
   * // set license country name
   * store.dispatch(actions.reservations.driverProfileState.set('drivers_license.country_name', {country_name:'United States'}));
   *
   * // set license country subdivision code
   * store.dispatch(actions.reservations.driverProfileState.set('drivers_license.country_subdivision_code', {country_subdivision_code:'IL'}));
   *
   * // set license country subdivision name
   * store.dispatch(actions.reservations.driverProfileState.set('drivers_license.country_subdivision_name', {country_subdivision_name:'Illinois'}));
   *
   * // set license expiration date
   * store.dispatch(actions.reservations.driverProfileState.set('license_expiration_date', {license_expiration_date:'05-12-2020'}));
   *
   * // set license issue date
   * store.dispatch(actions.reservations.driverProfileState.set('license_issue_date', {license_issue_date:'05-12-2000'}));
   *
   * // set license number
   * store.dispatch(actions.reservations.driverProfileState.set('license_number', {license_number:'DL******36***'}));
   *
   * */
  set(type = null, args) {
    return (dispatch) => {
      if (types(type).isString) {

        // Basic Info
        if (type === 'first_name') {
          dispatch(setDriverInfoFirstName(args.first_name));
        } else if (type === 'last_name') {
          dispatch(setDriverInfoLastName(args.last_name));
        } else if (type === 'date_of_birth') {
          dispatch(setDriverInfoDOB(args.date_of_birth));

          // Contact Info
        } else if (type === 'email') {
          dispatch(setDriverInfoEmail(args.email));
        } else if (type === 'phones') {
          dispatch(setDriverInfoPhones(args.phones));

          //Address Info
        } else if (type === 'city') {
          dispatch(setDriverInfoAddressCity(args.city));
        } else if (type === 'address.country_code') {
          dispatch(setDriverInfoAddressCountryCode(args.country_code));
        } else if (type === 'address.country_name') {
          dispatch(setDriverInfoAddressCountryName(args.country_name));
        } else if (type === 'address.country_subdivision_code') {
          dispatch(setDriverInfoAddressSubdivisionCode(args.country_subdivision_code));
        } else if (type === 'address.country_subdivision_name') {
          dispatch(setDriverInfoAddressSubdivisionName(args.country_subdivision_name));
        } else if (type === 'street_addresses') {
          dispatch(setDriverInfoAddressStreetAddresses(args.street_addresses));
        } else if (type === 'postal') {
          dispatch(setDriverInfoAddressPostal(args.postal));

          //License Info
        } else if (type === 'drivers_license.country_code') {
          dispatch(setDriverInfoDriverLicenseCountryCode(args.country_code));
        }else if (type === 'drivers_license.country_name') {
          dispatch(setDriverInfoDriverLicenseCountryName(args.country_name));
        }else if (type === 'drivers_license.country_subdivision_code') {
          dispatch(setDriverInfoDriverLicenseCountrySubdivisionCode(args.country_subdivision_code));
        }else if (type === 'drivers_license.country_subdivision_name') {
          dispatch(setDriverInfoDriverLicenseCountrySubdivisionName(args.country_subdivision_name));
        }else if (type === 'license_expiration_date') {
          dispatch(setDriverInfoDriverLicenseExpirationDate(args.license_expiration_date));
        }else if (type === 'license_issue_date') {
          dispatch(setDriverInfoDriverLicenseIssueDate(args.license_issue_date));
        }else if (type === 'license_number') {
          dispatch(setDriverInfoDriverLicenseNumber(args.license_number));
        } else {
          console.warn(`${type} is not a supported state type`);
        }
      } else {
        dispatch(setResDriverProfileState(args));
      }
    };
  },

  /**
   * @name unset
   * @desc A global unsetter for all reservation.driver_info data
   * @param {String} [type]
   * @param {Object} [args]
   * @returns {Function}
   * @memberof actions.reservations.driverProfileState
   * @example
   *
   * // unset first name
   * store.dispatch(actions.reservations.driverProfileState.unset('first_name'));
   *
   * // unset last name
   * store.dispatch(actions.reservations.driverProfileState.unset('last_name'));
   *
   * // unset date_of_birth name
   * store.dispatch(actions.reservations.driverProfileState.unset('date_of_birth'));
   *
   * // unset emal
   * store.dispatch(actions.reservations.driverProfileState.unset('email'));
   *
   * // unset phone numbers
   * store.dispatch(actions.reservations.driverProfileState.unset('phones'));
   *
   * // unset city
   * store.dispatch(actions.reservations.driverProfileState.unset('city'));
   *
   * // unset address country code
   * store.dispatch(actions.reservations.driverProfileState.unset('address.country_code'));
   *
   * // unset address country name
   * store.dispatch(actions.reservations.driverProfileState.unset('address.country_name'));
   *
   * // unset address subdivision country code
   * store.dispatch(actions.reservations.driverProfileState.unset('address.country_subdivision_code'));
   *
   * // unset address subdivision country name
   * store.dispatch(actions.reservations.driverProfileState.unset('address.country_subdivision_name'));
   *
   * // unset postal code
   * store.dispatch(actions.reservations.driverProfileState.unset('postal'));
   *
   * // unset street addresses
   * store.dispatch(actions.reservations.driverProfileState.unset('street_addresses'));
   *
   * // unset license country code
   * store.dispatch(actions.reservations.driverProfileState.unset('drivers_license.country_code'));
   *
   * // unset license country name
   * store.dispatch(actions.reservations.driverProfileState.unset('drivers_license.country_name'));
   *
   * // unset license country subdivision code
   * store.dispatch(actions.reservations.driverProfileState.unset('drivers_license.country_subdivision_code'));
   *
   * // unset license country subdivision name
   * store.dispatch(actions.reservations.driverProfileState.unset('drivers_license.country_subdivision_name'));
   *
   * // unset license expiration date
   * store.dispatch(actions.reservations.driverProfileState.unset('license_expiration_date'));
   *
   * // unset license issue date
   * store.dispatch(actions.reservations.driverProfileState.unset('license_issue_date'));
   *
   * // unset license number
   * store.dispatch(actions.reservations.driverProfileState.unset('license_number'));
   *
   * */
  unset(type = null) {
    return (dispatch) => {
      if (types(type).isString) {

        // Basic Info
        if (type === 'first_name') {
          dispatch(clearDriverInfoFirstName());
        } else if (type === 'last_name') {
          dispatch(clearDriverInfoLastName());
        } else if (type === 'date_of_birth') {
          dispatch(clearDriverInfoDOB());

          // Contact Info
        } else if (type === 'email') {
          dispatch(clearDriverInfoEmail());
        }  else if (type === 'phones') {
          dispatch(clearDriverInfoPhones());

          //Address Info
        } else if (type === 'city') {
          dispatch(clearDriverInfoAddressCity());
        } else if (type === 'address.country_code') {
          dispatch(clearDriverInfoAddressCountryCode());
        } else if (type === 'address.country_name') {
          dispatch(clearDriverInfoAddressCountryName());
        } else if (type === 'address.country_subdivision_code') {
          dispatch(clearDriverInfoAddressSubdivisionCode());
        } else if (type === 'address.country_subdivision_name') {
          dispatch(clearDriverInfoAddressSubdivisionName());
        } else if (type === 'street_addresses') {
          dispatch(clearDriverInfoAddressStreetAddresses());
        } else if (type === 'postal') {
          dispatch(clearDriverInfoAddressPostal());

          //License Info
        } else if (type === 'drivers_license.country_code') {
          dispatch(clearDriverInfoDriverLicenseCountryCode());
        }else if (type === 'drivers_license.country_name') {
          dispatch(clearDriverInfoDriverLicenseCountryName());
        }else if (type === 'drivers_license.country_subdivision_code') {
          dispatch(clearDriverInfoDriverLicenseCountrySubdivisionCode());
        }else if (type === 'drivers_license.country_subdivision_name') {
          dispatch(clearDriverInfoDriverLicenseCountrySubdivisionName());
        }else if (type === 'license_expiration_date') {
          dispatch(clearDriverInfoDriverLicenseExpirationDate());
        }else if (type === 'license_issue_date') {
          dispatch(clearDriverInfoDriverLicenseIssueDate());
        }else if (type === 'license_number') {
          dispatch(clearDriverInfoDriverLicenseNumber());
        }else if (type === 'contact') {
          dispatch(clearDriverInfoContact());
        }else if (type === 'address') {
          dispatch(clearDriverInfoAdress());
        }else if (type === 'drivers_license') {
          dispatch(clearDriverInfoDriversLicense());
        } else {
          console.warn(`${type} is not a supported state type`);
        }
      } else {
        dispatch(clearDriverInfoState());
      }
    };
  }
};



/**
 * @name searchProfileByDriverLicense
 * @desc Make the GMA profile/searchProfileByDriverLicense ; populates driver_info object on success
 * if option is_oci is set to true
 * @param {Object} data {payload, params}
 * @param {Object} requestOpts
 * @returns {Function}
 * @memberof actions.reservations
 * @example
 * const data = {
 *   payload: {
 *    "country":"US",
 *    "driver_license_number": "aabbccdd112",
 *    "last_name": "TESTEROV"
 *   },
 *   endpoint: {
 *    "is_oci": true
 *   }
 * }
 * store.dispatch(actions.reservations.searchProfileByDriverLicense(data));
 */
export function searchProfileByDriverLicense(data, requestOpts = {}) {
  return (dispatch) => {
    return dispatch(request({data, service: services.gma.profile.searchProfileByDriverLicense, opts: requestOpts}))
      .then(resp => {
        const {endpoint = {}} = data;

        if (!isArrayNotEmpty(resp.messages)) {

          if (endpoint.is_oci) {
            resp = get(resp, 'gma.online_check_in_profile');
          }

          dispatch(driverProfileState.set(null, resp));
        }

        return resp;
      });
  };
}

/**
 * @name searchRenterByMembership
 * @desc Make the GMA profile/searchRenterByMembership call; populates driver_info object on success
 * if option is_oci is set to true
 * @param {Object} data {
 *   loyalty_number: String,
 *   last_name: String
 * }
 * @param {Object} opts {
 *   is_oci: Boolean
 * }
 * @param {Object} requestOpts
 * @returns {Function}
 * @memberof actions.reservations
 * @example
 * const data = {
 *  payload: {
 *    "last_name":"TESTER",
 *    "loyalty_number": "932320196"
 *  },
 *  endpoint: {
 *    "is_oci": true
 *  }
 * store.dispatch(actions.reservations.searchRenterByMembership(data));
 */
export function searchRenterByMembership(data, requestOpts = {}) {
  return (dispatch) => {
    return dispatch(request({data, service: services.gma.profile.searchRenterByMembership, opts: requestOpts}))
      .then(resp => {
        const {endpoint = {}} = data;

        if (!isArrayNotEmpty(resp.messages)) {

          if (endpoint.is_oci) {
            resp = get(resp, 'gma.online_check_in_profile');
          }

          dispatch(driverProfileState.set(null, resp));
        }

        return resp;
      });
  };
}

/**
 * @name setResDriverProfileState
 * @desc Returns the actions to set driver profile information on reservation driver profile object
 * @param {Object} args
 * @returns {Function}
 */
function setResDriverProfileState(args = {}) {
  return dispatch => {
    const obj = args;
    let batchedActions = [];

    //Set Basic Info
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'profile.basic_profile.first_name', fn: setDriverInfoFirstName}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'profile.basic_profile.last_name', fn: setDriverInfoLastName}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'profile.basic_profile.date_of_birth', fn: setDriverInfoDOB}));

    //Set Contact Info
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'contact_profile.email', fn: setDriverInfoEmail}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'contact_profile.phones', fn: setDriverInfoStatePhones}));

    //Set Address Info
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'address_profile.street_addresses', fn: setDriverInfoStateStreetAddresses}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'address_profile.city', fn: setDriverInfoAddressCity}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'address_profile.country_subdivision_code', fn: setDriverInfoAddressSubdivisionCode}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'address_profile.country_subdivision_name', fn: setDriverInfoAddressSubdivisionName}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'address_profile.country_code', fn: setDriverInfoAddressCountryCode}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'address_profile.country_name', fn: setDriverInfoAddressCountryName}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'address_profile.postal', fn: setDriverInfoAddressPostal}));

    //Set License Info
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'license_profile.license_number', fn: setDriverInfoDriverLicenseNumber}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'license_profile.license_expiration_date', fn: setDriverInfoDriverLicenseExpirationDate}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'license_profile.country_subdivision_code', fn: setDriverInfoDriverLicenseCountrySubdivisionCode}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'license_profile.country_subdivision_name', fn: setDriverInfoDriverLicenseCountrySubdivisionName}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'license_profile.country_code', fn: setDriverInfoDriverLicenseCountryCode}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'license_profile.country_name', fn: setDriverInfoDriverLicenseCountryName}));
    batchedActions.push(callFunctionWithObjPathValues({obj, path: 'license_profile.license_issue_date', fn: setDriverInfoDriverLicenseIssueDate}));

    return dispatch(batchActions(...batchedActions.filter(action => action !== null)));
  };
}

/**
 * @name driverProfileModify
 * @desc Grabs the profile information for a reservation and modifys the users profile with that data. On completion
 * the reservation driver profile info is
 * @param {Object} requestOpts
 * @returns {Function}
 * @memberof actions.reservation
 * @example
 * dispatch(actions.reservations.driverProfileModify(opts));
 */
export function driverProfileModify(requestOpts = {}) {
  return (dispatch, getState) => {
    const payload = getState().getIn(['gmi', 'ui', 'reservations', 'driver_profile']).toJS();

    return dispatch(request({data:{payload}, service:services.gma.profile.modify, opts: requestOpts})).then(resp => {
      if (!isArrayNotEmpty(resp.messages)) {
        dispatch(driverProfileState.set(null, get(resp, 'gbo.profile')));
      }

      return resp;
    });
  };
}
